// routing
import React from "react";
import Routes from "./routes";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
// theme
import ThemeProvider from "./theme";
import "@fontsource/poppins";
import "./lang";
import "react-toastify/dist/ReactToastify.css";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./styles.css";

function App() {
    return (
        <ThemeProvider>
            <DndProvider backend={HTML5Backend}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Routes />
                </LocalizationProvider>
            </DndProvider>
        </ThemeProvider>
    );
}

export default App;
